import {
    AccountCircle as AccountIcon,
    Cloud as CloudIcon,
    Storage as StorageIcon,
    Transform as TransformIcon
} from '@mui/icons-material';
import {
    Box,
    Chip,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Typography,
} from '@mui/material';
import React from 'react';

const Design: React.FC = () => {
    return (
        <Box>
            <Typography variant="h3" component="h1" gutterBottom>
                System Design - Version 2.0
            </Typography>
            
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Architecture Overview
                </Typography>
                <Typography variant="body1" paragraph>
                    This application archives original media in their existing format
                    and makes them available for playback in modern web friendly format.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>Version 2.0 Major Update:</strong> Complete UI/UX redesign with Material-UI 
                    framework, unified navigation system, and modern responsive design patterns.
                </Typography>
            </Paper>

            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Version 2.0 Features & Improvements
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <TransformIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="Modern Material-UI Design System" 
                            secondary="Complete redesign with consistent theming, typography, and component library"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CloudIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="Unified Navigation System" 
                            secondary="Single AppBar navigation replacing old table-based secondary navigation"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <StorageIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="Enhanced File Management" 
                            secondary="Card-based file display with search, filtering, and improved metadata visualization"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <AccountIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="Responsive Layout System" 
                            secondary="Mobile-friendly design with adaptive navigation and optimized layouts"
                        />
                    </ListItem>
                </List>
            </Paper>

            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" gutterBottom>
                    AWS Infrastructure
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <AccountIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="AWS Account" 
                            secondary="359511245146"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <AccountIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="Primary Login" 
                            secondary="jeroen.j.dirks@gmail.com + Google Authenticator on Phone"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <StorageIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="S3 Upload Bucket" 
                            secondary="arn:aws:s3:::familyarchivecdkstack-uploaddestinationee0a48a0-1oi7tyuv2ea3j"
                        />
                        <Chip label="ca-central-1" size="small" color="primary" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CloudIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="DynamoDB Table" 
                            secondary="Media indexing and metadata storage"
                        />
                        <Chip label="ca-central-1" size="small" color="primary" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <TransformIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText 
                            primary="AWS Elastic Transcoder" 
                            secondary="Converts files to web-friendly formats (not available in ca-central-1)"
                        />
                        <Chip label="us-east-1" size="small" color="secondary" />
                    </ListItem>
                </List>
            </Paper>
        </Box>
    );
}

export default Design;
